"use strict";
/*
 * Created on 04 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Values required for Sellout price impact report calculations. All prices are without VAT.
 *
 * @author Jaroslav Sevcik
 */


var SelloutSourceImpactValues =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutSourceImpactValues, _DomainObject_1$Domai);

  /**
   * @param validFrom Start of validity of the values. Relates to {@link ExportedPriceHistory} intervals.
   * @param validTo End of validity of the values. Relates to {@link ExportedPriceHistory} intervals.
   * @param forecastOldForOneDay See {@link SelloutReleaseItemPrices#forecastOldForOneDay}.
   * @param forecastNewForOneDay See {@link SelloutReleaseItemPrices#forecastNewForOneDay}.
   * @param marginOldUnit See {@link SelloutReleaseItemPrices#marginOldUnit}.
   * @param marginNewUnit See {@link SelloutReleaseItemPrices#marginNewUnit}.
   * @param profitOldUnit See {@link SelloutReleaseItemPrices#profitOldUnit}.
   * @param profitNewUnit See {@link SelloutReleaseItemPrices#profitNewUnit}.
   * @param selloutPrice See {@link SelloutReleaseItemPrices#selloutPrice}. The value presented here is without VAT.
   * @param previousPrice See {@link SelloutReleaseItemPrices#regularPrice}. The value presented here is without VAT.
   * @param vatRate VAT in percents.
   */
  function SelloutSourceImpactValues(validFrom, validTo, forecastOldForOneDay, forecastNewForOneDay, marginOldUnit, marginNewUnit, profitOldUnit, profitNewUnit, selloutPrice, previousPrice, vatRate) {
    var _this;

    _classCallCheck(this, SelloutSourceImpactValues);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutSourceImpactValues).call(this));
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.forecastOldForOneDay = forecastOldForOneDay;
    _this.forecastNewForOneDay = forecastNewForOneDay;
    _this.marginOldUnit = marginOldUnit;
    _this.marginNewUnit = marginNewUnit;
    _this.profitOldUnit = profitOldUnit;
    _this.profitNewUnit = profitNewUnit;
    _this.selloutPrice = selloutPrice;
    _this.previousPrice = previousPrice;
    _this.vatRate = vatRate;
    return _this;
  }

  _createClass(SelloutSourceImpactValues, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutSourceImpactValues(mat.validFrom, mat.validTo, mat.forecastOldForOneDay, mat.forecastNewForOneDay, mat.marginOldUnit, mat.marginNewUnit, mat.profitOldUnit, mat.profitNewUnit, mat.selloutPrice, mat.previousPrice, mat.vatRate);
    }
  }]);

  return SelloutSourceImpactValues;
}(DomainObject_1.DomainObject);

exports.SelloutSourceImpactValues = SelloutSourceImpactValues;

SelloutSourceImpactValues.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutSourceImpactValues.name);
  return {
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.opt(builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)),
    forecastOldForOneDay: builder.opt(builder.bigNum('forecastOldForOneDay')),
    forecastNewForOneDay: builder.opt(builder.bigNum('forecastNewForOneDay')),
    marginOldUnit: builder.opt(builder.bigNum('marginOldUnit')),
    marginNewUnit: builder.opt(builder.bigNum('marginNewUnit')),
    profitOldUnit: builder.opt(builder.bigNum('profitOldUnit')),
    profitNewUnit: builder.opt(builder.bigNum('profitNewUnit')),
    selloutPrice: builder.opt(builder.bigNum('selloutPrice')),
    previousPrice: builder.opt(builder.bigNum('previousPrice')),
    vatRate: builder.opt(builder.bigNum('vatRate'))
  };
}();